export default typeof global !== 'undefined' ? global.location : { href: '' };
